import { render, staticRenderFns } from "./CarDriverAppointStaffEditComponent.vue?vue&type=template&id=4dce674b"
import script from "./CarDriverAppointStaffEditComponent.vue?vue&type=script&lang=js"
export * from "./CarDriverAppointStaffEditComponent.vue?vue&type=script&lang=js"
import style0 from "./CarDriverAppointStaffEditComponent.vue?vue&type=style&index=0&id=4dce674b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports